import { render, staticRenderFns } from "./reportedTickets.vue?vue&type=template&id=1e5ec5f5&scoped=true&"
import script from "./reportedTickets.vue?vue&type=script&lang=js&"
export * from "./reportedTickets.vue?vue&type=script&lang=js&"
import style0 from "./reportedTickets.vue?vue&type=style&index=0&id=1e5ec5f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5ec5f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VDivider,VFlex,VLayout,VProgressCircular})
